// extracted by mini-css-extract-plugin
export default {"cart-button-top-right":"ResaleCart_cart-button-top-right__Dx-KG"};